import { Maximize2 } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { PreviewMode } from "./preview-html-builder";

interface PreviewToolbarProps {
  mode: PreviewMode;
  onModeChange: (mode: PreviewMode) => void;
  onToggleFullscreen: () => void;
}

export function PreviewToolbar({ mode, onModeChange, onToggleFullscreen }: PreviewToolbarProps) {
  return (
    <div className="flex h-12 items-center justify-between border-b px-3">
      <span className="text-sm font-medium">미리보기</span>

      <div className="flex items-center gap-2">
        <Tabs value={mode} onValueChange={(v) => onModeChange(v as PreviewMode)}>
          <TabsList className="h-8">
            <TabsTrigger value="public" className="px-2 py-1 text-xs">
              Public
            </TabsTrigger>
            <TabsTrigger value="free" className="px-2 py-1 text-xs">
              Free
            </TabsTrigger>
            <TabsTrigger value="pro" className="px-2 py-1 text-xs">
              Pro
            </TabsTrigger>
          </TabsList>
        </Tabs>

        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button type="button" variant="ghost" size="icon" className="h-8 w-8" onClick={onToggleFullscreen} aria-label="전체화면 미리보기">
                <Maximize2 className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>전체화면 미리보기</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
}
